export const SaveGqlObjectMixin = {
  methods: {
    saveGqlObject(payload, createMutation, updateMutation) {
      let update = this.id != "";
      let mutation = update ? updateMutation : createMutation;
      let { __typename, ...vars } = payload;
      if (update) {
        vars.id = this.id;
      }
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: vars,

        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    saveGqlObjectHandler(result) {
        console.log(result);
    },
    saveGqlObjectErrorHandler(err){
        console.log(err);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/SaveGqlObjectMixin.js